import { Injectable } from '@angular/core';
import {AudienceDefinition, AudienceDefinitionList} from './audience_definition';
import {BaseService} from '../base/base.service';
import {AudienceDefinitionSerializer} from 'src/app/audience_definitions/audience_definition.serializer';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AudienceDefinitionService extends BaseService<AudienceDefinition, AudienceDefinitionList> {

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'audience_definitions' ;
    this.serializer = new AudienceDefinitionSerializer();
  }
}
